<div class="card mb-4">
    <div class="card-body">
  
      <div class="row">
        <!-- Grid column -->
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h4 class="mb-4 fw-bolder align-items-center">View Production Records</h4>
            </div>
        
          </div>

          <!-- Search filters -->
          <div class="row mb-4">
            <!-- Search Box -->
            <div class="col-md-3">
              <div class="form-group">
                <label for="searchOperator">Search by Operator</label>
                <input
                  type="text"
                  id="searchOperator"
                  class="form-control"
                  [(ngModel)]="searchOperator"
                  (ngModelChange)="filterTable()"
                  placeholder="Search Operator"
                />
              </div>
            </div>
      <!-- ticket is refno -->
            <div class="col-md-3">
              <div class="form-group">
                <label for="searchTicketNo">Search by Ref No.</label>
                <input
                  type="text"
                  id="searchTicketNo"
                  class="form-control"
                  [(ngModel)]="searchTicketNo"
                  (ngModelChange)="filterTable()"
                  placeholder="Search Ref No."
                />
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="searchDate">Search by Date</label>
                <input
                  type="date"
                  id="searchDate"
                  class="form-control"
                  [(ngModel)]="searchDate"
                  (ngModelChange)="filterTable()"
                />
              </div>
            </div>

          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <div class="table-responsive">
        <table class="table table-bordered red-border text-center">
          <thead>
            <tr>
              <th>Ref no</th>
              <th>PO No.</th>
             
              <th>Client Name</th>
              <th>Job Name</th>
              <th>Order Quantity</th>

              <th>Shift</th>

              <th>Machine</th>
              <th>Operator</th>
              <th>OperatingTime</th>
              <!-- <th>timeFrom</th>
              <th>timeTo</th> -->
              <th>McSpeed</th>
              <th>InkGsm</th>

              <!-- <th>Avl Time</th> -->

              <th>Input roll</th>
              <th>Ink Color</th>

              <!-- <th>Action</th> -->

              <th>Ticket</th>




            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let entry of materialMixEntries"> -->
              <tr *ngFor="let entry of paginatedEntries">
              <!-- <tr *ngFor="let entry of groupedEntries"> -->
                <td>{{ entry.refNo|| 'N/A'}}</td>
                <td>{{ entry.
                  poNumber
                  || 'N/A' }}</td>
                <td>{{ entry.clientName || 'N/A' }}</td>
                <td>{{ entry.jobName || 'N/A' }}</td>
                <td>{{ entry.orderKgs || 'N/A' }}</td>
                <td>{{ entry.shift || 'N/A' }}</td>
                <td>{{ entry.machine || 'N/A' }}</td>
                <td>{{ entry.operator || 'N/A' }}</td>
                <td>{{ entry.operatingTime || 'N/A' }}</td>
                <td>{{ entry.mcSpeed || 'N/A' }}</td>
                <td>{{ entry.inkGsm || 'N/A' }}</td>

                <!-- <td>{{ entry.addProduction[0]?.availTime || 'N/A' }}</td> -->
                <!-- <td>{{ entry.addProduction[0]?.matRollNo || 'N/A' }}</td> -->

                <!-- working -->
                <!-- <td><ng-container *ngIf="entry.addProduction?.length">
                  <td *ngFor="let addProd of entry.addProduction">
                    {{ addProd.matRollNo || 'N/A' }}
                  </td>
                </ng-container></td> -->
                <td>{{ getMatRollNoString(entry) }}</td>
                <td>{{ getInkColorString(entry) }}</td>
                
                

                <!--   [routerLink]="['/editproductionorderList', entry._id]" -->

                
                 <!-- <td class="div-flex"><button type="button" class="btn btn-outline-primary btn-sm"
                  [routerLink]="['/editprintingProduction', entry._id]"><i class="feather icon-edit "></i>Edit</button>
                  <button  class="btn btn-outline-danger btn-sm" (click)="deleteProduction(entry._id)"><i class="feather icon-trash-2"></i></button>
                </td> -->
              <!-- <td>
               
                <button type="button" class="btn btn-outline-success btn-sm" >
                  <i class="feather icon-edit text-success"></i> Save
                </button>
              </td> -->

              <td>
                <!-- <button type="button" (click)="print(entry)"> -->
                  <button type="button" (click)="printNewSep(entry)">
                  <i class="feather icon-printer"></i> Preview
                </button>
                <!-- <button type="button"   class="btn btn-success btn-sm mt-2" (click)="exportToExcel(entry)">
                  <i class="feather icon-download"></i> Excel
                </button> -->
              </td>



            </tr>
            
          </tbody>
        </table>
      </div>

    <!-- Pagination Controls -->

    <!-- total entries -->
    <span class="font-weight-bold">
      {{ (currentPage - 1) * itemsPerPage + 1 }} - 
      {{ currentPage * itemsPerPage > filteredEntries.length ? filteredEntries.length : currentPage * itemsPerPage }} 
      of {{ filteredEntries.length }} total
    </span>


    <div class="pagination-controls">
      <button
        class="btn btn-secondary"
        [disabled]="currentPage === 1"
        (click)="goToPage(currentPage - 1)"
      >
        <!-- Previous -->
        <i _ngcontent-guw-c91="" class="feather icon-chevrons-left"></i>
      </button>
     
      <!-- page info page 1 of 2 -->
      <!-- <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span> -->
       <!-- for only current page -->
       <span class="currentpage">{{ currentPage }}</span>

      <button
        class="btn btn-secondary"
        [disabled]="currentPage === totalPages"
        (click)="goToPage(currentPage + 1)"
      >
      <i _ngcontent-guw-c91="" class="feather icon-chevrons-right"></i>
      </button>
    </div>
     
      
    </div>
  </div>






  






  